import { configureCsrfTokenProvider } from './http'

export const xsrfCookieName = 'XSRF-TOKEN'

export function readCookieValue(cookieHeader: string, cookieName: string): string | undefined {
  for (const segment of cookieHeader.split(';')) {
    const entry = segment.trim()
    const separatorIndex = entry.indexOf('=')
    if (separatorIndex <= 0) continue
    if (entry.slice(0, separatorIndex) !== cookieName) continue

    const encodedValue = entry.slice(separatorIndex + 1)
    if (!encodedValue) return undefined
    try {
      return decodeURIComponent(encodedValue)
    } catch {
      return undefined
    }
  }
  return undefined
}

export function configureBrowserCsrfTokenProvider(): void {
  configureCsrfTokenProvider(() => {
    if (typeof document === 'undefined') return undefined
    return readCookieValue(document.cookie, xsrfCookieName)
  })
}
